import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { Mail, MessageCircle } from 'lucide-react';
import EmailSettings from './EmailSettings';
import SmsSettings from './SmsSettings';

const NotificationSettings = () => {
  const [tab, setTab] = useState(0);

  return (
    <Box>
      <Tabs
        value={tab}
        onChange={(_, newValue) => setTab(newValue)}
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab
          icon={<Mail size={16} />}
          iconPosition="start"
          label="Email Notifications"
          sx={{ textTransform: 'none', fontWeight: 500, minHeight: 48 }}
        />
        <Tab
          icon={<MessageCircle size={16} />}
          iconPosition="start"
          label="SMS Notifications"
          sx={{ textTransform: 'none', fontWeight: 500, minHeight: 48 }}
        />
      </Tabs>

      {tab === 0 && <EmailSettings />}
      {tab === 1 && <SmsSettings />}
    </Box>
  );
};

export default NotificationSettings;
